import EnvironmentInformation from "./EnvironmentInformation";

export default EnvironmentInformation;
